// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'view-design'
import axios from 'axios'
import store from './store/store'
import $ from 'jquery'

import 'view-design/dist/styles/iview.css'
import Api from './api/index.js'
import './assets/js/axios.js'
import cookie from './assets/js/cookie'
import htmlToPdf from './assets/js/htmlToPdf'
import Common from './assets/js/common'
Vue.prototype.common = Common

import i18n from './i18n/i18n'
import 'babel-polyfill'

Vue.prototype.$api = Api;
Vue.use(iView);
Vue.use(htmlToPdf);
Vue.use(i18n)

Vue.config.productionTip = false;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.$http = axios;
// axios.defaults.baseURL = 'http://172.18.102.40:1101/api/platform'
// axios.defaults.baseURL = 'http://139.199.158.198:1101/api/platform'
// axios.defaults.baseURL = 'http://203.195.160.234:1101/api/platform'
axios.defaults.baseURL = process.env.API_ROOT;
let bus = new Vue();
Vue.prototype.bus = bus;
/* eslint-disable no-new */
let _vue = new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: {App},
    template: '<App/>'
})
window.onload = function () {

    i18n.locale = cookie.get('language') || navigator.language.toLocaleLowerCase().substring(0, 2);
};

document.title = _vue.$i18n.messages[_vue.$i18n.locale].title;








// WEBPACK FOOTER //
// ./src/main.js